module.exports = __webpack_public_path__ + "img/application-2.5c09a26.png";